module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-ExtraLight.woff2?c57ab803a595b549ddb121b94f6d154a";